export default {
    // Header Section
    "discover_your": "अपनी खोजें",
    "personalized_report_2025": "व्यक्तिगत रिपोर्ट 2025",
    "comprehensive_life_blueprint": "व्यापक जीवन योजना",
    "personalized_report_2025_description": "2025 के लिए अपना संपूर्ण व्यक्तिगत ज्योतिषीय विश्लेषण प्राप्त करें। करियर, प्रेम, वित्त, स्वास्थ्य, परिवार और आध्यात्मिक विकास सहित सभी जीवन क्षेत्रों को कवर करने वाली व्यापक अंतर्दृष्टि के साथ मासिक मार्गदर्शन और व्यक्तिगत उपचार।",

    // Service Information
    "enter_details_for_personalized_analysis": "व्यक्तिगत विश्लेषण 2025 के लिए अपना विवरण दर्ज करें",
    "complete_personalized_analysis_2025": "संपूर्ण व्यक्तिगत विश्लेषण 2025",
    "service_price": "सेवा मूल्य",
    "comprehensive_personalized_analysis_note": "2025 भविष्यवाणियों और व्यक्तिगत मार्गदर्शन के साथ संपूर्ण जीवन विश्लेषण",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_personalized_analysis": "आपका नाम व्यक्तिगत ज्योतिषीय विश्लेषण के लिए अनूठी तरंगें बनाता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_comprehensive_analysis": "व्यापक ज्योतिषीय चार्ट और 2025 भविष्यवाणियों के लिए आवश्यक",
    "time_of_birth": "जन्म समय",
    "exact_time_comprehensive_analysis": "सटीक भाव गणना और विस्तृत विश्लेषण के लिए सटीक समय आवश्यक",
    "place_of_birth": "जन्म स्थान",
    "place_of_birth_placeholder": "शहर, राज्य, देश",
    "location_personalized_analysis": "स्थान व्यक्तिगत भविष्यवाणियों के लिए ग्रहों की स्थिति को प्रभावित करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपकी व्यक्तिगत रिपोर्ट चुनी गई भाषा में प्रदान की जाएगी",

    // Core 2025 Features
    "comprehensive_life_analysis": "व्यापक जीवन विश्लेषण",
    "year_2025_predictions": "वर्ष 2025 भविष्यवाणियां",
    "all_life_areas_analysis": "सभी जीवन क्षेत्रों का विश्लेषण",
    "personalized_remedies_solutions": "व्यक्तिगत उपचार और समाधान",
    "monthly_guidance_2025": "मासिक मार्गदर्शन 2025",
    "premium_pdf_report": "प्रीमियम पीडीएफ रिपोर्ट",

    "what_you_get": "आपकी व्यक्तिगत रिपोर्ट 2025 में क्या शामिल है",
    "complete_life_blueprint": "संपूर्ण जीवन योजना",
    "year_2025_forecast": "वर्ष 2025 पूर्वानुमान",
    "personalized_remedies": "व्यक्तिगत उपचार",
    "monthly_predictions_guide": "मासिक भविष्यवाणी गाइड",

    // Actions & Buttons
    "pay_and_generate_analysis": "मेरी व्यक्तिगत रिपोर्ट 2025 प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "विश्लेषण तैयार की जा रही है",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "personalized_analysis_processing": "2025 के लिए आपकी व्यापक व्यक्तिगत रिपोर्ट हमारे विशेषज्ञ ज्योतिषियों द्वारा तैयार की जा रही है। आपको मासिक मार्गदर्शन के साथ सभी जीवन क्षेत्रों को कवर करने वाली विस्तृत अंतर्दृष्टि प्राप्त होगी।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "विश्लेषण डिलीवरी",
    "within_48_hours_delivery_note": "आपकी व्यापक व्यक्तिगत रिपोर्ट 48 घंटों के भीतर तैयार हो जाएगी",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा विश्लेषण इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका व्यक्तिगत रिपोर्ट 2025 पैकेज",
    "comprehensive_personalized_report": "व्यापक व्यक्तिगत रिपोर्ट (पीडीएफ)",
    "complete_2025_predictions": "संपूर्ण 2025 भविष्यवाणियां",
    "all_life_areas_detailed_analysis": "सभी जीवन क्षेत्रों का विस्तृत विश्लेषण",
    "personalized_remedies_guide": "व्यक्तिगत उपचार गाइड",
    "monthly_action_plan_2025": "मासिक कार्य योजना 2025",

    // Visual Content
    "sample_personalized_analysis_2025": "नमूना व्यक्तिगत विश्लेषण 2025",
    "year_2025_focus": "वर्ष 2025 फोकस",
    "sample_2025_reading": "वित्तीय विस्तार के साथ करियर विकास और रिश्ते की स्थिरता",
    "sample_2025_preview": "व्यापक अंतर्दृष्टि के साथ आपके व्यक्तिगत 2025 विश्लेषण का पूर्वावलोकन",
    "year_2025_analysis_areas": "वर्ष 2025 विश्लेषण क्षेत्र",

    // 2025 Life Area Types
    "career_2025": "करियर 2025",
    "love_2025": "प्रेम 2025",
    "finance_2025": "वित्त 2025",
    "health_2025": "स्वास्थ्य 2025",
    "family_2025": "परिवार 2025",
    "spiritual_2025": "आध्यात्मिक 2025",

    // Status & Processing
    "your_personalized_analysis_status": "आपके व्यक्तिगत विश्लेषण की स्थिति",
    "processing_your_analysis": "आपकी व्यक्तिगत रिपोर्ट 2025 तैयार की जा रही है",
    "analysis_processing_message": "हमारे विशेषज्ञ ज्योतिषी विस्तृत 2025 भविष्यवाणियों और मासिक मार्गदर्शन के साथ सभी जीवन क्षेत्रों को कवर करने वाली आपकी व्यापक व्यक्तिगत रिपोर्ट तैयार कर रहे हैं।",
    "request_id": "विश्लेषण आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_48_hours": "रिपोर्ट 48 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "प्रीमियम सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया सभी आवश्यक जन्म विवरण पूरा करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "विश्लेषण प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // 2025 Year Overview
    "year_2025_overview": "वर्ष 2025 अवलोकन",
    "major_planetary_transits_2025": "प्रमुख ग्रहीय गोचर 2025",
    "key_astrological_events_2025": "मुख्य ज्योतिषीय घटनाएं 2025",
    "annual_theme_2025": "वार्षिक थीम 2025",
    "yearly_opportunities": "वार्षिक अवसर",
    "yearly_challenges": "वार्षिक चुनौतियां",

    // Monthly Analysis 2025
    "january_2025": "जनवरी 2025",
    "february_2025": "फरवरी 2025",
    "march_2025": "मार्च 2025",
    "april_2025": "अप्रैल 2025",
    "may_2025": "मई 2025",
    "june_2025": "जून 2025",
    "july_2025": "जुलाई 2025",
    "august_2025": "अगस्त 2025",
    "september_2025": "सितंबर 2025",
    "october_2025": "अक्टूबर 2025",
    "november_2025": "नवंबर 2025",
    "december_2025": "दिसंबर 2025",

    // Career 2025
    "career_forecast_2025": "करियर पूर्वानुमान 2025",
    "professional_growth_2025": "व्यावसायिक विकास अवसर",
    "job_changes_2025": "नौकरी में बदलाव और संक्रमण",
    "business_prospects_2025": "व्यापारिक संभावनाएं 2025",
    "leadership_opportunities_2025": "नेतृत्व के अवसर",
    "salary_increment_timing": "वेतन वृद्धि का समय",
    "career_challenges_2025": "करियर चुनौतियों का सामना करना",

    // Finance 2025
    "financial_forecast_2025": "वित्तीय पूर्वानुमान 2025",
    "income_growth_2025": "आय वृद्धि क्षमता",
    "investment_opportunities": "निवेश के अवसर",
    "expenditure_patterns": "व्यय पैटर्न",
    "wealth_accumulation": "धन संचय समयरेखा",
    "financial_challenges": "वित्तीय चुनौतियां",
    "money_management_tips": "धन प्रबंधन सुझाव",

    // Love & Relationships 2025
    "love_forecast_2025": "प्रेम पूर्वानुमान 2025",
    "relationship_developments": "रिश्ते के विकास",
    "marriage_prospects_2025": "विवाह की संभावनाएं 2025",
    "family_harmony": "पारिवारिक सद्भावना पूर्वानुमान",
    "romantic_opportunities": "रोमांटिक अवसर",
    "relationship_challenges": "रिश्ते की चुनौतियां",
    "love_life_enhancement": "प्रेम जीवन वृद्धि",

    // Health 2025
    "health_forecast_2025": "स्वास्थ्य पूर्वानुमान 2025",
    "vitality_levels": "2025 में जीवन शक्ति के स्तर",
    "health_vulnerable_periods": "स्वास्थ्य संवेदनशील अवधि",
    "wellness_recommendations": "कल्याण सिफारिशें",
    "fitness_goals_2025": "फिटनेस लक्ष्य 2025",
    "mental_health_focus": "मानसिक स्वास्थ्य फोकस क्षेत्र",
    "preventive_care_guidance": "निवारक देखभाल मार्गदर्शन",

    // Spiritual Growth 2025
    "spiritual_journey_2025": "आध्यात्मिक यात्रा 2025",
    "meditation_practices": "अनुशंसित ध्यान अभ्यास",
    "spiritual_awakening": "आध्यात्मिक जागृति के अवसर",
    "inner_growth_phases": "आंतरिक विकास चरण",
    "divine_connections": "दिव्य संबंध",
    "karmic_lessons_2025": "कार्मिक सबक 2025",

    // Personalized Remedies
    "customized_remedies": "2025 के लिए अनुकूलित उपचार",
    "gemstone_recommendations": "रत्न सिफारिशें",
    "mantra_suggestions": "मंत्र सुझाव",
    "ritual_guidance": "अनुष्ठान मार्गदर्शन",
    "charitable_activities": "लाभकारी दान गतिविधियां",
    "lifestyle_modifications": "जीवनशैली संशोधन",
    "lucky_colors_2025": "2025 के लिए भाग्यशाली रंग",
    "auspicious_dates": "शुभ तिथियां और समय",

    // Timing & Cycles
    "auspicious_periods_2025": "शुभ अवधि 2025",
    "challenging_periods": "चुनौतीपूर्ण अवधि का सामना करना",
    "optimal_decision_timing": "इष्टतम निर्णय लेने का समय",
    "new_venture_timing": "नए उद्यम शुरू करने का समय",
    "travel_recommendations": "यात्रा सिफारिशें",
    "important_date_alerts": "महत्वपूर्ण तिथि अलर्ट",

    // Personal Development 2025
    "skill_development_2025": "कौशल विकास फोकस 2025",
    "learning_opportunities": "सीखने के अवसर",
    "personal_growth_areas": "व्यक्तिगत विकास क्षेत्र",
    "character_development": "चरित्र विकास फोकस",
    "habit_formation": "लाभकारी आदत निर्माण",
    "goal_achievement_strategy": "लक्ष्य प्राप्ति रणनीति",

    // Social & Networking 2025
    "social_connections_2025": "सामाजिक संबंध 2025",
    "networking_opportunities": "नेटवर्किंग अवसर",
    "friendship_developments": "मित्रता विकास",
    "community_involvement": "सामुदायिक भागीदारी",
    "social_influence_growth": "सामाजिक प्रभाव विकास",

    // Technology & Innovation 2025
    "technology_adoption": "प्रौद्योगिकी अपनाने का मार्गदर्शन",
    "digital_opportunities": "डिजिटल अवसर",
    "innovation_potential": "नवाचार क्षमता",
    "online_presence": "ऑनलाइन उपस्थिति वृद्धि",
    "digital_financial_growth": "डिजिटल वित्तीय विकास",

    // Travel & Relocation 2025
    "travel_forecast_2025": "यात्रा पूर्वानुमान 2025",
    "relocation_possibilities": "स्थानांतरण संभावनाएं",
    "foreign_opportunities": "विदेशी अवसर",
    "pilgrimage_recommendations": "तीर्थयात्रा सिफारिशें",
    "educational_travel": "शैक्षिक यात्रा",

    // Legal & Official Matters 2025
    "legal_matters_guidance": "कानूनी मामलों का मार्गदर्शन",
    "official_work_timing": "आधिकारिक कार्य समय",
    "documentation_periods": "अनुकूल दस्तावेज़ अवधि",
    "government_dealings": "सरकारी व्यवहार",
    "property_matters": "संपत्ति संबंधी मामले",

    // Creative & Artistic 2025
    "creative_expression_2025": "रचनात्मक अभिव्यक्ति 2025",
    "artistic_pursuits": "कलात्मक गतिविधियां",
    "creative_projects": "रचनात्मक परियोजनाओं का समय",
    "artistic_collaborations": "कलात्मक सहयोग",
    "creative_income_potential": "रचनात्मक आय क्षमता",

    // Education & Knowledge 2025
    "educational_pursuits": "शैक्षिक गतिविधियां 2025",
    "skill_certifications": "कौशल प्रमाणन",
    "knowledge_expansion": "ज्ञान विस्तार क्षेत्र",
    "research_projects": "अनुसंधान परियोजनाएं",
    "teaching_opportunities": "शिक्षण के अवसर",

    // Environmental & Lifestyle 2025
    "living_environment": "जीवन पर्यावरण परिवर्तन",
    "lifestyle_upgrades": "जीवनशैली उन्नयन",
    "home_improvements": "घर सुधार का समय",
    "environmental_consciousness": "पर्यावरणीय चेतना",
    "sustainable_living": "टिकाऊ जीवन अभ्यास"
};
